import axios from 'axios'

function login(url: string, email: string, password: string) {
  return axios.post(url, null, {
    headers: { Authorization: 'Basic ' + btoa(`${email}:${password}`) },
  })
}

function register<T>(url: string, data: T) {
  return axios.post(url, data)
}

function logout(url: string) {
  return axios.post(url)
}

function getLoggedUserInfos<T>(url: string) {
  return axios.get<T>(url)
}

function updateLoggedUserInfos<T>(url: string, user: T) {
  return axios.put(url, user)
}

function forgotPassword(url: string, email: string) {
  return axios.post(url, { email: email })
}

function resetPassword(
  url: string,
  email: string,
  token: string,
  password: string
) {
  return axios.post(url, {
    email: email,
    token: token,
    password: password,
    password_confirmation: password,
  })
}

export {
  login,
  register,
  logout,
  getLoggedUserInfos,
  updateLoggedUserInfos,
  forgotPassword,
  resetPassword,
}
